export default "./src/client/components/auth/login/soap-ldap/img/user.png?b7342c31b93d38ccf28119820efcf09b";